import React from 'react';
import './PlanSettingsMenu.styl';
import {browserHistory} from 'react-router';
import GenericLink from 'components/GenericLink';
import AuthStore from 'stores/AuthStore';

import {RepProfileTab} from '@store/coaching-plans';
import {reviewPath} from 'components/dashboard/reviewPath';
import {EyeIcon} from '@components/icon/EyeIcon';
import {CommentIcon} from '@components/icon/CommentIcon';
import {CalendarDaysIcon} from '@components/icon/CalendarDaysIcon';
import {EditIcon} from '@components/icon/EditIcon';
import {TrashIcon} from '@components/icon/TrashIcon';

interface PlanSettingsMenuProps {
  editPlan: () => void;
  endPlan: () => void;
  editMeeting: () => void;
  canStartReview: boolean;
  canEditPlan: boolean;
  plan: any; // TODO
  review: any; // TODO
  rep: any; // TODO
  reviewFocused: boolean;
}

export default class PlanSettingsMenu extends React.PureComponent<PlanSettingsMenuProps> {
  render() {
    const {
      editPlan,
      endPlan,
      editMeeting,
      canStartReview,
      canEditPlan,
      review,
      rep,
      reviewFocused,
      plan,
    } = this.props;

    const sessionUser = AuthStore.getState().user;

    return (
      <div>
        {!plan.adHoc && (
          <ul className="plan-settings-menu">
            <li>
              <GenericLink
                onClick={() => {
                  browserHistory.push({
                    pathname: reviewPath(sessionUser),
                    query: {
                      tab: RepProfileTab.COACHING_PLANS,
                      teamId: rep.teamId,
                      userId: rep.id,
                      planId: review.planId,
                      reviewId: review.id,
                      // not autostarted
                    },
                  });
                }}>
                <div className="icon-wrapper preview">
                  <EyeIcon />
                </div>
                <span>Preview Meeting</span>
              </GenericLink>
            </li>
            {canStartReview && (
              <li>
                <GenericLink
                  onClick={() => {
                    browserHistory.push({
                      pathname: reviewPath(sessionUser),
                      query: {
                        tab: RepProfileTab.COACHING_PLANS,
                        teamId: rep.teamId,
                        userId: rep.id,
                        planId: review.planId,
                        reviewId: review.id,
                        autoStartReview: true,
                      },
                    });
                  }}>
                  <div className="icon-wrapper">
                    <CommentIcon />
                  </div>
                  <span>Start Meeting</span>
                </GenericLink>
              </li>
            )}
            {canEditPlan && (
              <li>
                <GenericLink onClick={editMeeting}>
                  <div className="icon-wrapper calendar">
                    <CalendarDaysIcon />
                  </div>
                  <span>{reviewFocused ? 'Edit Meeting' : 'Edit Next Meeting'}</span>
                </GenericLink>
              </li>
            )}
            {canEditPlan && (
              <li>
                <GenericLink onClick={editPlan}>
                  <div className="icon-wrapper edit">
                    <EditIcon />
                  </div>
                  <span>Edit Plan</span>
                </GenericLink>
              </li>
            )}
            {canEditPlan && (
              <li>
                <GenericLink onClick={endPlan}>
                  <div className="icon-wrapper trash">
                    <TrashIcon />
                  </div>
                  <span>End Plan</span>
                </GenericLink>
              </li>
            )}
          </ul>
        )}
        {plan.adHoc && (
          <ul className="plan-settings-menu">
            {canEditPlan && (
              <li>
                <GenericLink onClick={endPlan}>
                  <div className="icon-wrapper trash">
                    <TrashIcon />
                  </div>
                  <span>Cancel</span>
                </GenericLink>
              </li>
            )}
          </ul>
        )}
      </div>
    );
  }
}
